"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveSet = void 0;

var _lodash = require("lodash");

var _v = _interopRequireDefault(require("uuid/v4"));

var _middleware = require("@arranger/middleware");

var _esSearch = _interopRequireDefault(require("./utils/esSearch"));

var _compileFilter = _interopRequireDefault(require("./utils/compileFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var retrieveSetIds = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref) {
    var es, index, query, path, sort, _ref$BULK_SIZE, BULK_SIZE, _ref$trackTotalHits, trackTotalHits, search, handleResult;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            es = _ref.es, index = _ref.index, query = _ref.query, path = _ref.path, sort = _ref.sort, _ref$BULK_SIZE = _ref.BULK_SIZE, BULK_SIZE = _ref$BULK_SIZE === void 0 ? 1000 : _ref$BULK_SIZE, _ref$trackTotalHits = _ref.trackTotalHits, trackTotalHits = _ref$trackTotalHits === void 0 ? true : _ref$trackTotalHits;

            search = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _ref4,
                    searchAfter,
                    body,
                    response,
                    ids,
                    nextSearchAfter,
                    _args = arguments;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, searchAfter = _ref4.searchAfter;
                        body = _objectSpread(_objectSpread({}, !(0, _lodash.isEmpty)(query) && {
                          query: query
                        }), searchAfter && {
                          search_after: searchAfter
                        });
                        _context.next = 4;
                        return (0, _esSearch["default"])(es)({
                          index: index,
                          sort: sort.map(function (_ref5) {
                            var field = _ref5.field,
                                order = _ref5.order;
                            return "".concat(field, ":").concat(order || 'asc');
                          }),
                          size: BULK_SIZE,
                          track_total_hits: trackTotalHits,
                          body: body
                        });

                      case 4:
                        response = _context.sent;
                        ids = response.hits.hits.map(function (x) {
                          return (0, _lodash.get)(x, "_source.".concat(path.split('__').join('.')), x._id || '');
                        });
                        nextSearchAfter = sort.map(function (_ref6) {
                          var field = _ref6.field;
                          return response.hits.hits.map(function (x) {
                            return x._source[field] || x[field];
                          });
                        }).reduce(function (acc, vals) {
                          return [].concat(_toConsumableArray(acc), _toConsumableArray(vals.slice(-1)));
                        }, []);
                        return _context.abrupt("return", {
                          ids: ids,
                          searchAfter: nextSearchAfter,
                          total: response.hits.total.value
                        });

                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function search() {
                return _ref3.apply(this, arguments);
              };
            }();

            handleResult = /*#__PURE__*/function () {
              var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref7) {
                var searchAfter, total, _ref7$ids, ids, _yield$search, newIds, response;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        searchAfter = _ref7.searchAfter, total = _ref7.total, _ref7$ids = _ref7.ids, ids = _ref7$ids === void 0 ? [] : _ref7$ids;

                        if (!(ids.length === total)) {
                          _context2.next = 3;
                          break;
                        }

                        return _context2.abrupt("return", (0, _lodash.uniq)(ids));

                      case 3:
                        _context2.next = 5;
                        return search({
                          searchAfter: searchAfter
                        });

                      case 5:
                        _yield$search = _context2.sent;
                        newIds = _yield$search.ids;
                        response = _objectWithoutProperties(_yield$search, ["ids"]);
                        return _context2.abrupt("return", handleResult(_objectSpread(_objectSpread({}, response), {}, {
                          ids: [].concat(_toConsumableArray(ids), _toConsumableArray(newIds))
                        })));

                      case 9:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              }));

              return function handleResult(_x2) {
                return _ref8.apply(this, arguments);
              };
            }();

            _context3.t0 = handleResult;
            _context3.next = 6;
            return search();

          case 6:
            _context3.t1 = _context3.sent;
            return _context3.abrupt("return", (0, _context3.t0)(_context3.t1));

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function retrieveSetIds(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var saveSet = function saveSet(_ref9) {
  var types = _ref9.types,
      getServerSideFilter = _ref9.getServerSideFilter;
  return /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(obj, _ref10, context) {
      var type, userId, sqon, path, sort, _ref10$refresh, refresh, _types$find$, nestedFields, index, es, projectId, query, ids, body;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              type = _ref10.type, userId = _ref10.userId, sqon = _ref10.sqon, path = _ref10.path, sort = _ref10.sort, _ref10$refresh = _ref10.refresh, refresh = _ref10$refresh === void 0 ? 'WAIT_FOR' : _ref10$refresh;
              _types$find$ = types.find(function (_ref12) {
                var _ref13 = _slicedToArray(_ref12, 2),
                    x = _ref13[1];

                return x.name === type;
              })[1], nestedFields = _types$find$.nested_fields, index = _types$find$.index;
              es = context.es, projectId = context.projectId;
              query = (0, _middleware.buildQuery)({
                nestedFields: nestedFields,
                filters: (0, _compileFilter["default"])({
                  clientSideFilter: sqon,
                  serverSideFilter: getServerSideFilter(context)
                })
              });
              _context4.next = 6;
              return retrieveSetIds({
                es: es,
                index: index,
                query: query,
                path: path,
                sort: sort && sort.length ? sort : [{
                  field: '_id',
                  order: 'asc'
                }]
              });

            case 6:
              ids = _context4.sent;
              body = {
                setId: (0, _v["default"])(),
                createdAt: Date.now(),
                ids: ids,
                type: type,
                path: path,
                sqon: sqon,
                userId: userId,
                size: ids.length
              };
              _context4.next = 10;
              return es.index({
                index: _middleware.CONSTANTS.ES_ARRANGER_SET_INDEX,
                id: body.setId,
                refresh: refresh.toLowerCase(),
                body: body
              });

            case 10:
              return _context4.abrupt("return", body);

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x3, _x4, _x5) {
      return _ref11.apply(this, arguments);
    };
  }();
};

exports.saveSet = saveSet;